import { render, staticRenderFns } from "./PromotionNew.vue?vue&type=template&id=19cc361f&"
import script from "./PromotionNew.vue?vue&type=script&lang=js&"
export * from "./PromotionNew.vue?vue&type=script&lang=js&"
import style0 from "./PromotionNew.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports